import { render } from "./modal.vue?vue&type=template&id=572806db&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=572806db&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572806db"]])

export default __exports__